<section [ngClass]="modalType=='edit'? 'grey-M':'white'" *ngIf="viewType=='add' || viewType=='edit'">
    <form class="form-horizontal"  enctype="multipart/form-data" [formGroup]="schoolForm" >
    <div *ngIf="modalType=='edit'" class="row" style="margin-right:0px;" [dir]="textDir">
         <!-- <div class="container-slider" style="margin-right:20px;" *ngIf="viewType=='add'">
            <label *ngIf="this.schoolForm.get('active').value !== true" style="padding-right:5px;color: #9b9b9b">Active</label>
            <label *ngIf="this.schoolForm.get('active').value === true" style="padding-right:5px;">Active</label>
            <label class="switch1">
                <input type="checkbox" #status
                [checked]="this.schoolForm.get('active').value !== true"
                (change)="confirmEnableDisable($event.target.checked)">
                <span class="slider round"></span>
            </label>
            <label *ngIf="this.schoolForm.get('active').value === true" style="padding-left:10px;color: #9b9b9b">Archived</label>
            <label *ngIf="this.schoolForm.get('active').value !== true"style="padding-left:10px;">Archived</label>
        </div> 
 -->

        <div class="spaceBtwn" *ngIf="viewType=='add'">
            <div class="marT8">
              <label *ngIf="data?.active === true" class="labeltxt disabled padT5">{{'Archived' | translate }}</label>
              <label *ngIf="data?.active !== true" class="labeltxt padT5">{{'Archived' | translate }}</label> 
            </div>
            <div class="padL10" [ngClass]="textDir=='ltr'?'padL10':'padR10'">
                <label class="switch">
                    <input type="checkbox" id="usrStatus" #usrstatus [checked]="data?.active === true" (change)="confirmEnableDisable($event.target.checked)" [dir]="textDir">
                    <i class="ball"></i>
                    <span data-enabled="Active" data-disabled="Archived" style="display: none;"></span>
                </label>
            </div>
            <div class="marT8"> 
                <label *ngIf="data?.active !== true" class="labeltxt disabled padT5" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate }}</label>
                <label *ngIf="data?.active === true" class="labeltxt padT5" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate }}</label>
            </div>
           
          </div>
       
       <!--  <div>
            <div class="sm-12 item-middle" style="height: 126px;">
                <span style="margin-left: 8px;margin-top: 27px;">
                   <app-ctl-logo-upload
                    image=true
                    bucket="school"
                    type="logo"
                    wrapperClass="ctlInputFile"
                    imgClass="round" style="margin-left: 22px; margin-top:10px;width:87px;height:87px;"
                    [imgSource]="this.schoolForm.get('logo').value?.url || 'assets/images/upload_image.png'"
                    [myForm]="schoolForm">
                    </app-ctl-logo-upload>


                </span>
                <div style="display: flex;" *ngIf="project_id  && (this.schoolForm.get('logo').value?.url)">
                    <a href="javascript:void(0);" style="margin-left: 25px;" (click)="removePhoto();">Remove photo</a>
                </div>
            </div>
        </div> -->
        <div class="row top-header spaceBtwn" >
            <div class="item-middle flexStart">
              <!-- <img [src]="fixLogoUrl(this.data?.logo?.url) || 'assets/images/upload_image.png'" class="img-circle img-responsive" alt='.'> -->
              <app-ctl-logo-upload
                image=true
                bucket="project"
                type="logo"
                wrapperClass="ctlInputFile"
                imgClass="round"
                [imgSource]="this.schoolForm.get('logo').value?.url || 'assets/images/upload_image.png'"
                [myForm]="this.schoolForm"               
                >
              </app-ctl-logo-upload>

              <div class="logo-title" [ngClass]="textDir=='ltr'?'marL15':'marR15'">
                <div class="title t-hgt30">{{this.data?.name}}</div>
                <div class="">
                    <div style="display: flex;" *ngIf="project_id  && (this.schoolForm.get('logo').value?.url)">
                      
                        <a class="removePhoto" (click)="removePhoto();">{{'Remove photo' | translate}}</a>
                    </div>
                </div>
              </div>
            </div>
          </div>

    </div>
    <div id="schoolContainer" class="white-container padB15 pad30" [ngClass]="modalType=='edit'? 'height355':''" >
       <ng-container *ngIf="viewType !='edit'">
       <div class="title" >
        <label>{{'New school details'|translate}}</label> 
       </div>
       <div class="padB10">
        <label class="labeltxt">{{projectName}}, {{myCountry?.name}}</label> 
       </div>
    </ng-container>
        <div class="row" [ngClass]="viewType !='edit'?'marT20':''">
            <div class="form-group flexStart sm-12 ">
                <div class="labelwid"><label class="labeltxt">{{'School name'|translate}}</label></div>
                <div class="sm-8">
                <input type="text" class="form-control txtW" formControlName="name" maxlength="35" placeholder="{{'Enter school name (max. 35 characters)'|translate}}" (input)="nameChanged($event)" [dir]="textDir">
                <div class="hgt-20"  >
                    <ng-container *ngIf="this.schoolForm.get('name').invalid && (this.schoolForm.get('name').dirty || this.schoolForm.get('name').touched)">
                    <small *ngIf="this.schoolForm.get('name').errors || this.schoolForm.get('name').errors.required">
                        <span class="alert" [ngClass]="textDir=='rtl'?'marR5':''">{{'Please enter name'|translate}}.</span>
                    </small>
                </ng-container>
                </div>
            </div>
            </div>
        </div>

        <div class="row" >
            <div class="form-group flexStart dim2" formGroupName="contact">
                <div class="labelwid"><label class="labeltxt">{{'Address' | translate }}</label></div>
                <div class="sm-8">
                <input type="text" class="form-control txtW" formControlName="address" placeholder="{{'Enter school address'|translate}}" [dir]="textDir">
                </div>
            </div>
        </div>

        <div class="row marT20" [dir]="textDir">
            <div class="form-group flexStart sm-12">
                <div class="labelwid"><label class="label-light">{{'Region' | translate }}</label></div>
                <div [ngClass]="curView =='addschool'?'sm-8':''">
                    <div [ngClass]="textDir =='rtl'?'marR10':'marL0'" >
                        <ng-container *ngIf="this.schoolForm.controls?.region?.value?._id === 'new'">
                            <input #newregion type="text" class="form-control" placeholder="Ex. South Myanmar" [ngClass]="curView =='addschool'?'region-txt':'region-txt'" [dir]="textDir">
                            &nbsp;
                            <button class="btn primary check" (click)="addRegion(newregion.value)">
                                <i class="icon icon-check"></i>
                            </button>
                            &nbsp;
                            <button class="btn primary cross" (click)="this.schoolForm.get('region').patchValue(null)">
                                <i class="icon icon-cross" ></i>
                            </button>
                        </ng-container>
                       <div class="txtW" [ngClass]="textDir" [dir]="textDir">
                           <ngx-select-dropdown class="ngx-dropup" *ngIf="this.schoolForm.controls?.region?.value?._id !== 'new'" [multiple]="false" formControlName="region" [options]="myRegionList" [config]="regionSelectConfig" (change)="regionChange();"></ngx-select-dropdown>
                        </div> 

                    </div>
                </div>
            </div>
        </div>


        <div class="row marT20">
            <div class="form-group flexStart">
                <div class="labelwid"><label class="labeltxt">{{'Category' | translate }}</label></div>
                <div class="txtW" [ngClass]="textDir =='rtl'?'marR10 rtl':''" [dir]="textDir">
                    
                    <ngx-select-dropdown class="ngx-dropup" [multiple]="false" formControlName="category" [options]="mySchoolCategoryList" [config]="categorySelectConfig"></ngx-select-dropdown>
                   
                </div>
            </div>
        </div>

        <div class="row marT20">
            <div class="form-group flexStart" formGroupName="contact">
                <div class="labelwid"><label class="labeltxt">{{'Phone no' | translate }} <span *ngIf="modalType!='edit'" class="optional">*</span></label></div>

                <div class="txtW" [ngClass]="textDir =='rtl'?'marR2':''">
                <input type="text" class="form-control txtW" formControlName="phone" maxlength="14" placeholder="{{'Enter phone number' | translate }}" [dir]="textDir">

            <div class=" hgt-20" >
                <ng-container *ngIf="this.schoolForm.get('contact.phone').invalid && (this.schoolForm.get('contact.phone').dirty || this.schoolForm.get('contact.phone').touched)">
               
                <small *ngIf="this.schoolForm.get('contact.phone').errors || this.schoolForm.get('contact.phone').errors.pattern">
                    <span class="alert" [ngClass]="textDir=='rtl'?'marR5':''">{{'Please enter valid phone number' | translate }}.</span>
                </small>
                </ng-container>
            </div>
        </div>
            </div>
        </div>

        <div class="row">
            <div class="form-group flexStart" formGroupName="contact">
                <div class="labelwid"><label class="labeltxt">{{'Website' | translate }} <span *ngIf="modalType!='edit'" class="optional">*</span></label></div>

                <div class="sm-8">
                <input type="text" class="form-control txtW" formControlName="url" placeholder="Ex. www.school.org" [dir]="textDir">

            <div class="hgt-20" >
                   <ng-container *ngIf="this.schoolForm.get('contact.url').invalid && (this.schoolForm.get('contact.url').dirty || this.schoolForm.get('contact.url').touched)">
                <small *ngIf="this.schoolForm.get('contact.url').errors || this.schoolForm.get('contact.url').errors.pattern">
                        <span class="alert" [ngClass]="textDir=='rtl'?'marR5':''">{{'Please enter school website' | translate }}.</span>
                    </small>
                </ng-container>
                </div>
            </div>
            </div>
        </div>

      
       
      

        <div class="row" *ngIf="modalType==='edit'" >
            <div class="form-group flexStart ">
                <div class="labelwid"><label class="label-light">{{'CTL code' | translate}}</label></div>
                <div class="txtW" [ngClass]="textDir=='rtl'?'marR10':''">
                    <label calss="labeltxt" >{{this.schoolForm.get('code').value}}</label>
                </div>
            </div>
        </div>

        <!-- <div class="row marT15" *ngIf="modalType==='edit'">
            <div class="form-group flexStart">
                <div class="labelwid"><label class="label-light">CTL token</label></div>
                <div class="txtW">
                <label class="labeltxt" >{{this.schoolForm.get('token').value}}</label>
                </div>
            </div>
        </div> -->

        <!-- <div class="row marT15" >
            <div class="form-group flexStart dim2" style="margin-top: -2px;">
                <div class="labelwid"><label class="labeltxt">Project</label></div>
                <div class="sm-8">
                    <label class="label600" >{{projectName}}</label>
                </div>
            </div>
        </div> -->
        <div class="clearfix"></div>
      
        <div class="row" *ngIf="modalType!='edit'">
            <div class="item-middle flexStart">
                <div class="labelwid"><label class="labeltxt">{{'School logo' | translate}} <span class="optional">*</span></label></div>
                
                <div [ngClass]="textDir=='rtl'?'marR10':''">
                <app-ctl-logo-upload
                    image=true
                    bucket="school"
                    type="logo"
                    wrapperClass="ctlInputFile"
                    imgClass="round"
                    [imgSource]="this.schoolForm.get('logo').value?.url || 'assets/images/upload_image.png'"
                    [myForm]="schoolForm">
                </app-ctl-logo-upload>
            </div>
            </div>
        </div>

        <div class="row marT5" >
            <div *ngIf="modalType!='edit'" class="pull-right marT5">                
                <label class="labeltxt opac-60"> <span class="optional"></span>{{'Optional' | translate}}</label>
            </div>
        </div>

    </div>
    </form>
</section>
<section class="grey-M" *ngIf="viewType=='read'" [ngClass]="viewType!='read'?'padT10':''" >
    <ng-container *ngIf="viewType=='read'">
        <div class="row top-header spaceBtwn">
            <div class="sm-8 item-middle">
                <img [src]="this.data?.logo?.url || 'assets/images/upload_image.png'"  class="img-circle img-70 img-responsive" alt='.'>
                <div  [ngClass]="textDir=='ltr'?'padL10':'padR10'">
                    <div class="head-one"><label class="form-title">{{data?.name}}</label></div>
                    <div class="head-two"><label class="label-light">{{data?.country?.name}}</label></div>
                </div>
              </div>

           <!--    <div class="sm-6 container-slider">
                <label *ngIf="data?.active !== true" style="padding-right:5px;color: #9b9b9b">Active</label>
                <label *ngIf="data?.active === true" style="padding-right:5px;">Active</label>
                <label class="switch">
                  <input type="checkbox"
                    [checked]="data?.active !== true"
                    (change)="confirmEnableDisable($event.target.checked)">
                  <span class="slider round"></span>
                </label>
                <label *ngIf="data?.active === true" style="padding-left:10px;color: #9b9b9b">Archived</label>
                <label *ngIf="data?.active !== true"style="padding-left:10px;">Archived</label>


              </div> -->

              <div class="marT10 spaceBtwn" *ngIf="viewType=='read'">
                <div class="">
                  <label *ngIf="data?.active === true" class="labeltxt disabled padT5">{{'Archived' | translate}}</label>
                  <label *ngIf="data?.active !== true" class="labeltxt padT5">{{'Archived' | translate}}</label> 
                </div>
                <div class="" style="margin-top: -5px;" [ngClass]="textDir=='ltr'?'padL5':'padR5'">
                    <label class="switch">
                        <input type="checkbox" id="usrStatus" #usrstatus [checked]="data?.active === true" (change)="confirmEnableDisable($event.target.checked)" [dir]="textDir">
                        <i class="ball"></i>
                        <span data-enabled="Active" data-disabled="Archived" style="display: none;"></span>
                    </label>
                </div>
                <div class=""> 
                    <label *ngIf="data?.active !== true" class="labeltxt disabled padT5" [ngClass]="textDir=='ltr'?'padL5':'padR5'">{{'Active' | translate}}</label>
                    <label *ngIf="data?.active === true" class="labeltxt padT5" [ngClass]="textDir=='ltr'?'padL5':'padR5'">{{'Active' | translate}}</label>
                </div>
              </div>


        </div>
     
    </ng-container>
    <div>
    
    <div class="clearfix"></div>
      <div class="white-container" [ngClass]="viewType=='read'? 'height365': ''" >
        <div class="sm-12 marT20 view flexStart">
            <div class="labelwid"><label class="label-light">{{'School name'|translate}}</label></div>
          <div class="txtW">
          
            <label class="labeltxt">{{data?.name}}</label>
            <!-- <label>{{}}</label> -->
         
        <!--   <div *ngIf="edited" style="width: 80px;padding: 0px;">
              <a (click)="edit()" class="edit" >
                  <i class="glyphicon glyphicon-pencil"></i>
                  &nbsp;&nbsp;Edit detailsnnn
              </a>
          </div>  -->
        </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'Phone no' | translate }}.</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.contact?.phone}}</label>
              <!-- <label class="labeltxt">{{this.data?.description}}</label> -->
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'Website' | translate }}</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.contact?.url}}</label>
              <!-- <label class="labeltxt">{{this.data?.country?.name}}</label> -->
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'Address' | translate }}</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.contact?.address}}</label>
              <!-- <label class="labeltxt">{{this.myLeadPartner?.partner?.name}}</label> -->

            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'Region' | translate }}</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.region?.name}}</label>
              <!-- <label class="labeltxt">{{this.myLeadPartner?.partner?.name}}</label> -->

            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'Category' | translate }}</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.category?.name}}</label>
              <!-- <label class="labeltxt">{{this.myLeadPartner?.partner?.name}}</label> -->

            </div>
        </div>
        <div class="clearfix"></div>
        <div class="sm-12 view marT15 flexStart">
            <div class="labelwid"><label class="label-light">{{'CTL Code'| translate}}</label></div>
            <div class="txtW">
                    <label class="labeltxt">{{data?.code}}</label>
              <!-- <label class="labeltxt">{{this.myLeadPartner?.partner?.name}}</label> -->

            </div>
        </div>

        <div class="clearfix"></div>
        <div class="sm-12 view padB30 marT15 flexStart" >
            <div class="labelwid"><label class="label-light">{{'Project' | translate }}</label></div>
            <div class="txtW" >
                    <label class="labeltxt">{{projectName}}</label>
                    <!-- <label>{{this.myLeadPartner?.partner?.name}}</label> -->
            </div>
        </div>
               
      </div>
    </div>
  </section>
